"use client";

import Lenis from "lenis";
import { useEffect, type ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export function LenisProvider({ children }: Props) {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (prefersReduced) return;

    // autoRaf: Lenis kendi RAF loop'unu yönetir, manuel kurulum gerekmez.
    // autoToggle: scroll olmadığında RAF'ı durdurur — Lighthouse TBT'yi
    // dramatik düşürür (idle'da 60fps'lik döngü CPU yiyiyordu).
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      autoRaf: true,
      autoToggle: true,
    });

    return () => {
      lenis.destroy();
    };
  }, []);

  return <>{children}</>;
}
